module.exports = __webpack_public_path__ + "static/media/roundaboutCW315.38d7c885.svg";